    var xpmap = document.createElement('script');
    xpmap.type = 'text/javascript';
    xpmap.async = true;
    xpmap.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyBgd36wwsddQn9LMIP1Qb53xgNiaeREmtY&callback=loadMap';
    var zpmap = document.getElementsByTagName('script')[0];
    zpmap.parentNode.insertBefore(xpmap, zpmap);

function loadMap() {
  var the_addy = $('.contact-info').data('address');
  var geocoder = new google.maps.Geocoder();
  var mapOp = false;
  geocoder.geocode({
    'address': the_addy
  }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      var mapOp = {
        zoom: 17,
        center: results[0].geometry.location,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        styles: [{
          "featureType": "landscape",
          "stylers": [{
            "color": "#F6E6DB"
          }, ]
        }, {
          "featureType": "road.local",
          "stylers": [{
            "color": "#DBCDC3"
          }, ]
        }, {
          "featureType": "transit",
          "stylers": [{
            "saturation": -100
          }, {
            "visibility": "simplified"
          }]
        }, {
          "featureType": "administrative.province",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "water",
          "stylers": [{
            "visibility": "on"
          }, {
            "lightness": 30
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#B8ADA5"
          }, ]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#D0BAAF"
          }, ]
        }, ]
      };
      var map = new google.maps.Map(document.getElementById('the-map'), mapOp);
      var marker = new google.maps.Marker({
        map: map,
        position: results[0].geometry.location
      });

    }

  });
}